module.exports = __webpack_public_path__ + "static/media/introduction_v7.926571f8.png";